/**
 * 친구 초대 링크 기억 (2026-10-17 사장님). chordscore.com/?ref=회원번호 로 들어오면 이 기기에 30일 기억한다.
 * 이메일 가입은 가입 화면 추천인 칸에 고정으로, 카카오·구글 가입은 로그인 뒤 ReferralClaim 이 서버에 붙인다.
 */
// 토스 카드 결제가 열릴 때 같이 켠다 (사장님 10/17). 꺼져 있으면 메뉴·추천인 붙이기 안 함 (링크 기억만)
export const INVITE_ENABLED = false;

const KEY = "cs_ref";
const KEEP = 30 * 24 * 60 * 60 * 1000;

export const captureRef = () => {
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref && /^\d{1,9}$/.test(ref)) localStorage.setItem(KEY, JSON.stringify({ ref, t: Date.now() }));
  } catch (e) { /* 기억 못 해도 그냥 */ }
};

export const getRef = (): string => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (v && v.ref && Date.now() - v.t < KEEP) return String(v.ref);
  } catch (e) { /* 없음 */ }
  return "";
};

export const clearRef = () => {
  try { localStorage.removeItem(KEY); } catch (e) { /* 그냥 */ }
};
